'use strict';
import isFunction from 'lodash/isFunction';


ChildModelDeletedManager.$inject = [];

export function ChildModelDeletedManager() {

  this.watchModel = watchModel;

  function watchModel(model, callback, scope) {
    let cancelListener;
    cancelListener = __bindListener(model, function onUpdate() {
      if (model.isDeleting) {
        if (cancelListener) {
          cancelListener();
          cancelListener = null;
        }
        callback();
      }
    });

    scope.$on('$destroy', function () {
      if (cancelListener) {
        cancelListener();
        cancelListener = null;
      }
    });

    return cancelListener;
  }

  function __bindListener(model, callback) {
    model.$on('update', callback);

    return function () {
      if (model && isFunction(model.$off)) {
        model.$off('update', callback);
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/js/app-model/ChildModelDeletedManager.js